import { Component, computed, input } from '@angular/core';
import { TabComponent } from '../../../components/tab/tab.component';
import { APITableComponent } from '../../../components/table/api-table/api-table.component';
import { TabLayoutComponent } from '../../../components/tab-layout/tab-layout.component';

@Component({
  selector: 'app-products-performance-tab',
  imports: [APITableComponent, TabLayoutComponent],
  templateUrl: './products-performance-tab.component.html',
  providers: [
    { provide: TabComponent, useExisting: ProductsPerformanceTabComponent },
  ],
})
export class ProductsPerformanceTabComponent extends TabComponent {
  override name = this.dictionaryService.get('ProductsPerformance');

  userId = input<string>();
  endpoint = computed(() => {
    const base = '/visits/tables/products-performance-details';
    const id = this.userId();
    return id ? `${base}/${id}` : base;
  });

  public async main(): Promise<void> {}
}
